var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5127 4.41154C22.7037 8.0084 23.1853 14.3217 19.5885 18.5127C15.9916 22.7037 9.67828 23.1853 5.48729 19.5885C1.2963 15.9916 0.814671 9.67828 4.41154 5.48729C8.0084 1.2963 14.3217 0.81467 18.5127 4.41154ZM17.1442 17.8645L5.423 7.80494C3.3623 11.0268 3.93445 15.3566 6.92009 17.919C9.90572 20.4814 14.2722 20.3901 17.1442 17.8645ZM17.0799 6.081C20.0655 8.64339 20.6377 12.9732 18.577 16.1951L6.8558 6.13548C9.72775 3.60989 14.0943 3.51861 17.0799 6.081Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveWhite);
export default __webpack_public_path__ + "static/media/Inactive_white.4c0b5597e21a18b73741a9b732e353d2.svg";
export { ForwardRef as ReactComponent };